export default __webpack_public_path__ + "static/media/go.3589c3e9.svg";